import { api } from '../../client';

export interface BillLineItemDto {
  id: string;
  description: string;
  quantity: number;
  price: number;
  tax_percentage: number;
  line_total: number;
}

export interface BillDto {
  id: string;
  bill_number: string;
  vendor_id: string;
  vendor_name: string;
  bill_date: string;
  due_date: string;
  vendor_invoice_ref?: string;
  notes?: string;
  subtotal?: number;
  tax_amount?: number;
  total_amount: number;
  balance_due: number;
  status: string;
  line_items?: BillLineItemDto[];
}

export const purchasesBillsApi = {
  async list(
    search?: string
  ): Promise<{ data?: BillDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/purchases/bills${q}`) as Promise<{ data?: BillDto[] }>;
  },

  async get(id: string): Promise<{ data?: BillDto; message?: string }> {
    return api.get(`/purchases/bills/${id}`) as Promise<{ data?: BillDto }>;
  },

  async create(data: {
    vendor_id: string;
    bill_date: string;
    due_date: string;
    vendor_invoice_ref?: string;
    notes?: string;
    line_items: { description: string; quantity: number; price: number; tax_percentage?: number }[];
  }): Promise<{ data?: BillDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/purchases/bills', data) as Promise<{
      data?: BillDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      vendor_id?: string;
      bill_date?: string;
      due_date?: string;
      vendor_invoice_ref?: string;
      notes?: string;
      status?: string;
      line_items?: { description: string; quantity: number; price: number; tax_percentage?: number }[];
    }
  ): Promise<{ data?: BillDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/purchases/bills/${id}`, data) as Promise<{
      data?: BillDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/purchases/bills/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
